import styles from './styles.module.css';
import { FC, ReactNode } from 'react'
import HeaderImg from "src/assets/images/header.webp";


interface HeaderProp {
    title?: string | null,
    children?: ReactNode | null
}

const Header: FC<HeaderProp> = ({ title, children }) => {
    return (
        <header className={styles.header}>
            <img src={HeaderImg} alt={title || "Almadkhal"} />
            <div className={styles.overlay}>
                <h4 className="">
                    {Boolean(title) && title}
                    {Boolean(children) && children}
                </h4>
            </div>

        </header>

    )
}

export default Header;